import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Typography,
  StepContent,
  Paper,
} from "@mui/material";
import { Grid } from "@mui/system";
import { HowToStep } from "../Constants";
import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/styles.min.css";
import { getImageSrc } from "../../../utils/getImageSrc";

type Props = {
  activeStep: number;
  handleStep: (step: number) => void;
  howToSteps: Array<HowToStep>;
};

const SmallDeviceSteps = ({ activeStep, handleStep, howToSteps }: Props) => {
  return (
    <Box maxWidth={"100%"}>
      <Stepper nonLinear activeStep={activeStep} orientation="vertical">
        {howToSteps.map((howToStep, index) => (
          <Step key={howToStep.title}>
            <StepLabel
              onClick={() => handleStep(index)}
              style={{ cursor: "pointer" }}
            >
              {howToStep.title}
            </StepLabel>
            <StepContent>
              <Box display={"flex"} flexDirection={"column"}>
                {howToStep.body.map((line, index) => (
                  <Typography variant="body1" key={line}>
                    {`${index + 1}. ${line}`}
                  </Typography>
                ))}
                <Grid
                  container
                  spacing={1}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  {howToSteps[activeStep].images.map((image) => (
                    <Grid
                      size={howToSteps[activeStep].images.length > 1 ? 6 : 12}
                      key={image.filename}
                    >
                      <Paper
                        sx={{
                          backgroundColor: (theme) =>
                            theme.palette.mode === "light"
                              ? theme.palette.grey[200]
                              : theme.palette.grey[600],
                          padding: 1,
                          maxWidth: "428px",
                          borderColor: (theme) =>
                            theme.palette.mode === "light"
                              ? theme.palette.grey[100]
                              : theme.palette.grey[800],
                        }}
                      >
                        <InnerImageZoom
                          src={getImageSrc(
                            image.filename,
                            image.folderName,
                            true,
                          )}
                          imgAttributes={{ alt: image.alt }}
                          hideCloseButton
                          hideHint
                          width={428}
                          height={926}
                        />
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default SmallDeviceSteps;
